module.exports = __webpack_public_path__ + "static/media/CountdownTimerIcon.70cef2d1.svg";